const state = () => ({
  selectedChannels: [],
  channels: [],
});

const mutations = {
  setChannelsSelected(state, payload) {
    state.selectedChannels = payload;
  },
  setChannels(state, payload) {
    state.channels = payload;
  },
  selectAllChannels(state) {
    state.selectedChannels = state.channels.map((channel) => channel.guid);
  },
};

export default {
  namespaced: true,
  mutations,
  state,
};
